import { SxProps, Theme } from "@mui/material";

// styleClsx: Merges style objects for the `style` prop on HTML elements
export function styleClsx(
    ...styles: Array<React.CSSProperties | false | null | undefined>
): React.CSSProperties {
    return Object.assign({}, ...styles.filter(Boolean));
}

// sxClsx: Merges style objects for the `sx` prop on MUI components
// Accepts any object (MUI sx can be objects, arrays, or functions, but this covers the common case)
export function sxClsx(
    ...styles: Array<SxProps<Theme> | false | null | undefined>
): SxProps {
    return Object.assign({}, ...styles.filter(Boolean));
}
